import LoadingScreen from "components/LoadingScreen";
import useAuth from "hooks/useAuth";
import AuthLayout from "layouts/AuthLayout";
import EmailPageContainer from "pages/email_send_page/skeleton/EmailPageContainer";
import { ReactNode, useState } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useSelector } from "redux/store";

type AuthGuardProps = {
  children: ReactNode;
};

export default function GuestGuard({ children }: AuthGuardProps) {
  const { allowed, isLoading } = useAuth();
  const customer = useSelector((state: any) => state.customer.customer);
  const { pathname } = useLocation();
  const [requestedLocation, setRequestedLocation] = useState<string | null>(
    null
  );

  if (isLoading) {
    return <LoadingScreen />;
  }

  if (allowed && localStorage.getItem("token")) {
    const currentCustomerId = window.location.pathname.split("/")[1];
    if (customer?.isOnboardingDone) {
      return <Navigate to={"/" + currentCustomerId + "/documents"} />;
    } else {
      return <Navigate to={"/" + currentCustomerId + "/onboarding"} />;
    }
  }

  if (!allowed || !localStorage.getItem("token")) {
    if (pathname !== requestedLocation) {
      setRequestedLocation(pathname);
    }
    return (
      <AuthLayout>
        <EmailPageContainer />
      </AuthLayout>
    );
  }

  if (requestedLocation && pathname !== requestedLocation) {
    setRequestedLocation(null);
    return <Navigate to={requestedLocation} />;
  }

  return <>{children}</>;
}
